import React, { useEffect, useState } from "react";
import { RickyTutorial } from "./RickyTutorial";
import { ScreenPortal } from "./MobileZoom";

const CRACKERS = '[data-testid^="pyro-cracker-base-"]';
const ENERGY = '[data-testid="pyro-energy-amount"]';

// Re-applies a glow class while active (React re-renders may reset className).
export function useGlow(selector) {
  useEffect(() => {
    if (!selector) return;
    const apply = () => document.querySelectorAll(selector).forEach((el) => el.classList.add("pyro-tut-glow"));
    apply();
    const id = setInterval(apply, 250);
    return () => {
      clearInterval(id);
      document.querySelectorAll(selector).forEach((el) => el.classList.remove("pyro-tut-glow"));
    };
  }, [selector]);
}

// Ricky's first-visit Pyro walkthrough: unlock a spark → upgrade it → 5 energy reward.
export function PyroTutorial({ stage, sparkSelector, onReward, onDone }) {
  const [glow, setGlow] = useState(null);
  useGlow(glow);
  const flash = (sel, ms) => {
    setGlow(sel);
    if (ms) setTimeout(() => setGlow((g) => (g === sel ? null : g)), ms);
  };

  let tut = null;
  if (stage === "crackers") {
    tut = <RickyTutorial key="crackers" noBlock stay side="center" compact steps={[
      { text: "Wanna light up the arena, baby? First, you need CRACKERS! Click a cracker and unlock a spark!", onEnter: () => flash(CRACKERS, 1200) },
    ]} />;
  } else if (stage === "upgrade") {
    tut = <RickyTutorial key="upgrade" noBlock stay side="center" compact steps={[
      { text: "OWWWWWW! These sparks are so bright, I'm getting CATARACTS! MY EYES! THE PYRO IS TOO MUCH!", onEnter: () => setGlow(null) },
      { text: "UPGRADE A SPARK with ENERGY and COLLECTIBLES, BABY! LET'S LIGHT UP THE STAGE!", onEnter: () => flash(sparkSelector) },
    ]} />;
  } else if (stage === "reward") {
    tut = <RickyTutorial key="reward" noBlock exitAfter side="center" compact onFinish={onDone} steps={[
      { text: "THAT'S MY SUPERSTAR! FULL ENERGY, BABY!", onEnter: async () => { setGlow(null); await onReward(); flash(ENERGY, 3000); } },
      { text: "Now let me get outta here before my titanium hip starts sparking! OWWWWWWW!" },
    ]} />;
  }

  return (
    <ScreenPortal>
      <div data-testid={`pyro-tutorial-${stage}`}>{tut}</div>
      <style>{`.pyro-tut-glow { filter: brightness(1.35) drop-shadow(0 0 8px #FFE600) drop-shadow(0 0 20px #FFE600) !important; }`}</style>
    </ScreenPortal>
  );
}
